module.exports = __webpack_public_path__ + "static/media/icon_alert_no_verif_new_x2.69c88bf1.png";